/**
 * --------------------------------------------------------
 * MCH Quote Engine
 * Version: 1.0
 * Shopify Online Store 2.0
 * --------------------------------------------------------
 */

class QuoteEngine {

    constructor() {

        this.form = document.getElementById('InsuranceQuoteForm');

        if (!this.form) {
            return;
        }

        this.steps = Array.from(
            this.form.querySelectorAll('.quote-step')
        );

        this.successScreen =
            this.form.querySelector('.quote-success');

        this.progressBar =
            this.form.querySelector('.quote-progress__fill');

        this.progressText =
            this.form.querySelector('.quote-progress__text');
            this.progressSteps =
            this.form.querySelectorAll('.quote-progress__step');

        this.nextButtons =
            this.form.querySelectorAll('.quote-next');

        this.prevButtons =
            this.form.querySelectorAll('.quote-prev');

        this.submitButton =
            this.form.querySelector('.quote-submit');

        this.bodyField =
            this.form.querySelector('#quote-body');

        this.state = {

            currentStep: 0,

            totalSteps: this.steps.length,

            submitting: false,

            submitted: false

        };

        this.init();

    }

    /**
     * ---------------------------------------
     * Initialize
     * ---------------------------------------
     */

    init() {

        this.bindNavigation();

        this.bindValidation();

        this.updateProgress();

        this.showStep(0);

        if (window.quoteSubmitted) {

            this.finish();

        }

    }

    /**
     * ---------------------------------------
     * Event Binding
     * ---------------------------------------
     */

    bindNavigation() {

        this.nextButtons.forEach(button => {

            button.addEventListener('click', () => {

                this.next();

            });

        });

        this.prevButtons.forEach(button => {

            button.addEventListener('click', () => {

                this.previous();

            });

        });

        this.form.addEventListener('submit', (event) => {

    if (!this.validateCurrentStep()) {

        event.preventDefault();
        return;

    }

    this.setLoading(true);

    const data = this.serialize();

    if (this.bodyField) {

        this.bodyField.value = this.buildEmailBody(data);

    }

    // Allow the browser to submit the form normally.
    // Do NOT call event.preventDefault() here.

});

       

    }

    bindValidation() {

        const fields = this.form.querySelectorAll(

            'input, select, textarea'

        );

        fields.forEach(field => {

            field.addEventListener('input', () => {

                this.clearError(field);

            });

            field.addEventListener('change', () => {

                this.clearError(field);

            });

        });

    }
    /**
     * ---------------------------------------
     * Step Navigation
     * ---------------------------------------
     */

    showStep(index) {

        this.steps.forEach((step, i) => {

            step.classList.toggle('active', i === index);

        });

        this.state.currentStep = index;

        this.updateProgress();

        this.scrollToTop();

    }

    next() {

        if (!this.validateCurrentStep()) {
            return;
        }

        if (this.state.currentStep < this.state.totalSteps - 1) {

            this.showStep(

                this.state.currentStep + 1

            );

        }

    }

    previous() {

        if (this.state.currentStep > 0) {

            this.showStep(

                this.state.currentStep - 1

            );

        }

    }

    /**
     * ---------------------------------------
     * Progress
     * ---------------------------------------
     */

    updateProgress() {

        if (!this.progressBar) {
            return;
        }

        const percent =

            ((this.state.currentStep + 1) /

            this.state.totalSteps) * 100;

        this.progressBar.style.width =

            percent + '%';
if (this.progressSteps) {

    this.progressSteps.forEach((step, index) => {

        step.classList.toggle(
            'active',
            index <= this.state.currentStep
        );

    });

}
        if (this.progressText) {

            this.progressText.textContent =

                `Step ${this.state.currentStep + 1} of ${this.state.totalSteps}`;

        }

    }

    /**
     * ---------------------------------------
     * Scroll
     * ---------------------------------------
     */

    scrollToTop() {

        const card =

            document.querySelector('.quote-card');

        if (!card) {
            return;
        }

        card.scrollIntoView({

            behavior: 'smooth',

            block: 'start'

        });

    }    /**
     * ---------------------------------------
     * Validation
     * ---------------------------------------
     */

    validateCurrentStep() {

        const step = this.steps[this.state.currentStep];

        const requiredFields = step.querySelectorAll(

            '[required]'

        );

        let valid = true;

        requiredFields.forEach(field => {

            if (!this.validateField(field)) {

                valid = false;

            }

        });

        return valid;

    }

    validateField(field) {

        this.clearError(field);

        const value = field.value.trim();

        if (field.hasAttribute('required') && value === '') {

            this.showError(field, 'This field is required.');

            return false;

        }

        if (

            field.type === 'email' &&

            value !== '' &&

            !this.isEmail(value)

        ) {

            this.showError(

                field,

                'Please enter a valid email.'

            );

            return false;

        }

        if (

            field.type === 'tel' &&

            value !== '' &&

            !this.isPhone(value)

        ) {

            this.showError(

                field,

                'Please enter a valid phone number.'

            );

            return false;

        }

        return true;

    }

    isEmail(email) {

        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    }

    isPhone(phone) {

        const digits = phone.replace(/\D/g, '');

        return digits.length >= 10;

    }

    /**
     * ---------------------------------------
     * Errors
     * ---------------------------------------
     */

    showError(field, message) {

        field.classList.add('is-invalid');

        let error =

            field.parentElement.querySelector(

                '.quote-error'

            );

        if (!error) {

            error = document.createElement('div');

            error.className = 'quote-error';

            field.parentElement.appendChild(error);

        }

        error.textContent = message;

    }

    clearError(field) {

        field.classList.remove('is-invalid');

        const error =

            field.parentElement.querySelector(

                '.quote-error'

            );

        if (error) {

            error.remove();

        }

    }    /**
     * ---------------------------------------
     * Serialize Form
     * ---------------------------------------
     */

    serialize() {

        const data = {};

        const fields = this.form.querySelectorAll(

            'input, select, textarea'

        );

        fields.forEach(field => {

            if (!field.name) {
                return;
            }

            const key = field.name
                .replace('contact[', '')
                .replace(']', '');

            data[key] = field.value.trim();

        });

        return data;

    }

    /**
     * ---------------------------------------
     * Build Email Body
     * ---------------------------------------
     */

    buildEmailBody(data) {

        return `Insurance Quote Request

----------------------------------------

First Name:
${data.first_name || ''}

Last Name:
${data.last_name || ''}

Email:
${data.email || ''}

Phone:
${data.phone || ''}

ZIP Code:
${data.zip || ''}

Insurance Type:
${data.insurance_type || ''}

Current Carrier:
${data.current_carrier || ''}

Policy Expiration:
${data.policy_expiration || ''}

Coverage Amount:
${data.coverage_amount || ''}

Property / Vehicle ZIP:
${data.property_zip || ''}

Preferred Contact Method:
${data.contact_method || ''}

Additional Comments:
${data.comments || ''}

----------------------------------------

Generated by MCH Quote Engine
`;

    }

    /**
     * ---------------------------------------
     * Loading State
     * ---------------------------------------
     */

    setLoading(loading) {

        this.state.submitting = loading;

        if (!this.submitButton) {
            return;
        }

        this.submitButton.disabled = loading;

        this.submitButton.textContent =

            loading

                ? 'Submitting...'

                : 'Submit Quote Request';

    }    /**
     * ---------------------------------------
     * Submit
     * ---------------------------------------
     */

    submit() {

        if (!this.validateCurrentStep()) {
            return;
        }

        this.setLoading(true);

        const data = this.serialize();

        if (this.bodyField) {

            this.bodyField.value =

                this.buildEmailBody(data);

        }

        /*
        ----------------------------------------
        IMPORTANT

        We intentionally let Shopify handle the
        submission normally.

        DO NOT use fetch() here.

        Shopify already knows how to process
        contact forms and redirect back with
        form.posted_successfully?

        That keeps everything reliable.

        ----------------------------------------
        */

        this.form.submit();

    }

    /**
     * ---------------------------------------
     * Finish
     * ---------------------------------------
     */

    finish() {

        this.state.submitted = true;

        this.steps.forEach(step => {

            step.style.display = 'none';

        });

        const progress =

            this.form.querySelector('.quote-progress');

        if (progress) {

            progress.style.display = 'none';

        }
        const card =
        this.form.closest('.quote-card');

        if (card) {

    const header =
        card.querySelector('.quote-card__header');

    if (header) {

        header.style.display = 'none';

    }

}
        if (this.successScreen) {

            this.successScreen.style.display = 'block';

        }

        this.setLoading(false);

    }    /**
     * ---------------------------------------
     * Reset
     * ---------------------------------------
     */

    reset() {

        this.form.reset();

        this.state.currentStep = 0;

        this.state.submitting = false;

        this.state.submitted = false;

        this.steps.forEach(step => {

            step.style.display = '';

        });

        if (this.successScreen) {

            this.successScreen.style.display = 'none';

        }

        const progress =

            this.form.querySelector('.quote-progress');

        if (progress) {

            progress.style.display = '';

        }

        this.showStep(0);

    }

    /**
     * ---------------------------------------
     * Submit Error
     * ---------------------------------------
     */

    showSubmitError(message) {

        this.setLoading(false);

        alert(

            message ||

            'Something went wrong. Please try again.'

        );

    }

}/**
 * ---------------------------------------
 * Boot
 * ---------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {

    new QuoteEngine();

});